import ProjectGuard from "@/components/common/ProjectGuard/ProjectGuard";
import ProjectAuthProvider from "@/components/common/ProjectAuthProvider/ProjectAuthProvider";

export default [
  {
    path: "MicroserviceList",
    name: "MicroServiceList",
    component: () =>
      import(
        // "../pages/main/modernframework/MicroServiceV2/MicroServiceListV2.vue"
        "../pages/main/modernframework/MicroServiceV2/ApplicationList.vue"
      ),
  },
  {
    path: "/projects",
    component: ProjectAuthProvider,
    children: [
      {
        path: "",
        component: ProjectGuard,
        children: [
          {
            path: ":projectId/profiles/:profileId/microservices/:microserviceId/clone",
            component: () =>
              import("@/pages/application/ApplicationClonePage.vue"),
          },

          {
            path: ":projectId/profiles/:profileId/microservices/:microserviceId/modify",
            name: "MicroServiceModifyPageV2",
            component: () =>
              import(
                "@/pages/main/modernframework/MicroServiceDetailV2/MicroServiceModifyPageV2.vue"
              ),
          },
          {
            path: ":projectId/profiles/:profileId/microservices/:microserviceId",
            name: "MicroServiceDetail",
            component: () =>
              import(
                "../pages/main/modernframework/MicroServiceDetailV2/MicroServiceDetailPageV2.vue"
              ),
          },
          {
            path: ":projectId/profiles/:profileId/microservices/:microserviceId/modify",
            name: "MicroServiceModify",
            component: () =>
              import("@/pages/application/ApplicationModifyPage.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "projects/:projectId/microservices",
    name: "ProjectMicroservices",
    component: () =>
      import("../pages/main/modernframework/Project/ProjectMicroservices.vue"),
  },
];
